<script setup lang="ts">
    import { UserIcon } from '@heroicons/vue/24/outline';
    import Button from '@/shared/ui/Button/Button.vue';
    import { useDialogs } from '@/shared/ui/Dialog';
    import AuthenticationDialog from '@/components/Global/AuthenticationDialog/AuthenticationDialog.vue';

    const dialogs = useDialogs();
    const showLoginModal = () => dialogs.open(AuthenticationDialog);
</script>

<template>
    <Button
        variant="secondary"
        :icon-left="UserIcon"
        @click="showLoginModal"
    >
        {{ $t('USER.SIGN_IN') }}
    </Button>
</template>
